import { createContext } from "react";
import {
  PlanCellCoordinatesWithOptionalPerson,
  PlanCellWithIndex,
} from "./data/plan";
import { HistoryState, MealKey, CookingOverrides } from "./utils/planUtils";

export type DrawerHistoryContextType = {
  history: HistoryState[];
  pushHistory: (state: HistoryState) => void;
  popHistory: () => void;
  clearHistory: () => Promise<void>;
  closeDrawer: () => void;
  hasHistory: (state: HistoryState["id"]) => boolean;
  setWindowHistoryStackSize: (size: number) => void;
};
const emptyDrawerHistoryContext: DrawerHistoryContextType = {
  history: [],
  pushHistory: () => {},
  popHistory: () => {},
  clearHistory: async () => {},
  closeDrawer: () => {},
  hasHistory: () => false,
  setWindowHistoryStackSize: () => {},
};
export const DrawerHistoryContext = createContext<DrawerHistoryContextType>(
  emptyDrawerHistoryContext,
);
export type MealPlannerContextType = {
  submitPlanCells: (planCells: PlanCellWithIndex[]) => void;
  onConsume: (
    date: string,
    mealInd: string,
    mealKey: MealKey | undefined,
    personId: number | undefined,
    overrides?: CookingOverrides,
  ) => void;
  getTableDataForCoordinates: (
    coords: PlanCellCoordinatesWithOptionalPerson,
  ) => PlanCellWithIndex[];
};

export const MealPlannerContext = createContext<MealPlannerContextType>({
  submitPlanCells: () => {},
  onConsume: () => {},
  getTableDataForCoordinates: () => [],
  ...emptyDrawerHistoryContext,
});
